export const cardNameNormalizer = (name) => name.replaceAll("--", "-").replaceAll("//", "/").replaceAll(/[, ]/g, "-").replaceAll("-/-", "/")
